<template>
  <div class="md-layout">
    <simple-wizard class="md-layout-item">
      <template slot="header">
        <h3 class="title">Crea tu perfil de cliente</h3>
        <h5 class="category">
          Esta información servirá para conocerte más.
        </h5>
      </template>
      <wizard-tab :before-change="() => validateStep('step1')">
        <template slot="label"> Información Personal </template>
        <first-step ref="step1" @on-validated="onStepValidated1"></first-step>
      </wizard-tab>

      <wizard-tab :before-change="() => validateStep('step2')">
        <template slot="label"> Información Laboral </template>
        <second-step ref="step2" @on-validated="onStepValidated2"></second-step>
      </wizard-tab>

      <wizard-tab :before-change="() => validateStep('step3')">
        <template slot="label"> Referencias Personales y Laborales </template>
        <third-step ref="step3" @on-validated="wizardComplete"></third-step>
      </wizard-tab>
    </simple-wizard>
  </div>
</template>
<script>
import FirstStep from "./ProfileRegistrationWizard/FirstStep.vue";
import SecondStep from "./ProfileRegistrationWizard/SecondStep.vue";
import ThirdStep from "./ProfileRegistrationWizard/ThirdStep.vue";
import Swal from "sweetalert2";
import { SimpleWizard, WizardTab } from "@/components";
import gql from "graphql-tag";
import axios from "axios";
import store from "../../store";
import Constants from "../../constants";
import { onLogin } from "../../vue-apollo.js";

export default {
  data() {
    return {
      wizardModel: {},
      capDomainVehicleType: null,
      capDomainsLiveWith: null,
      capDomainCivilStatus: null,
      capDomainSocialELevel: null,
      capDomainIncomeSalary: null,
      capDomainMonthlyExpenses: null,
      capDomainStudyLevel: null,
      capDomainEmployment: null,
      capCityResidence: null,
      capDomainHowKnowCap: null,
      capDomainBank: null,
      profileBank: null,
      capDomainEnterpriseSectorId: null,
      capDomainContractTypeId: null,
      clientJob: null
    };
  },
  components: {
    FirstStep,
    SecondStep,
    ThirdStep,
    SimpleWizard,
    WizardTab
  },
  methods: {
    validateStep(ref) {
      return this.$refs[ref].validate();
    },
    onStepValidated1(
      validated,
      model,
      sex,
      liveWith,
      civilStatus,
      socialELevel,
      cityResidence
    ) {
      this.capDomainVehicleType = sex;
      this.capDomainsLiveWith = liveWith;
      this.capDomainCivilStatus = civilStatus;
      this.capDomainSocialELevel = socialELevel;
      this.capCityResidence = cityResidence;
      this.wizardModel = { ...this.wizardModel, ...model };
    },
    onStepValidated2(
      validated,
      model,
      incomeSalary,
      monthlyExpenses,
      studyLevel,
      employment,
      clientJob,
      enterpriseSector,
      contractType
    ) {
      this.capDomainIncomeSalary = incomeSalary;
      this.capDomainMonthlyExpenses = monthlyExpenses;
      this.capDomainStudyLevel = studyLevel;
      this.capDomainEmployment = employment;
      this.wizardModel = { ...this.wizardModel, ...model };
      this.clientJob = clientJob;
      this.capDomainContractTypeId = contractType;
      this.capDomainEnterpriseSectorId = enterpriseSector;
    },
    beforeClose(event) {
      var x = 0;
      var intervalID = setInterval(function() {
        if (this.isLoading) {
          event.cancel();
        } else window.clearInterval(intervalID);
        if (++x === 3) {
          window.clearInterval(intervalID);
        }
      }, 100);
    },
    wizardComplete(
      validated,
      model,
      refFRelation,
      refPRelation,
      howKnowCap,
      capDomainBank,
      profileBank
    ) {
      this.wizardModel = { ...this.wizardModel, ...model };
      this.capDomainRefFRelation = refFRelation;
      this.capDomainRefPRelation = refPRelation;
      this.capDomainHowKnowCap = howKnowCap;
      this.capDomainBank = capDomainBank;
      this.profileBank = profileBank;
      this.$apollo.mutate({
        mutation: gql`
          mutation createProfile(
            $profile: pProfile!
            $capAccountAccountId: Int!
            $capCityResidence: Int!
            $capDomainSocialELevel: Int!
            $capDomainStudyLevel: Int!
            $capDomainVehicleType: Int!
            $capDomainCivilStatus: Int!
            $capDomainIncomeSalary: Int!
            $capDomainMonthlyExpenses: Int!
            $capDomainRefPRelation: Int!
            $capDomainRefFRelation: Int!
            $capDomainHowKnowCap: Int!
            $capDomainsLiveWith: [Int!]
            $capDomainEmployment: Int!
          ) {
            createProfile(
              profile: $profile
              capAccountAccountId: $capAccountAccountId
              capCityResidence: $capCityResidence
              capDomainSocialELevel: $capDomainSocialELevel
              capDomainStudyLevel: $capDomainStudyLevel
              capDomainVehicleType: $capDomainVehicleType
              capDomainCivilStatus: $capDomainCivilStatus
              capDomainIncomeSalary: $capDomainIncomeSalary
              capDomainMonthlyExpenses: $capDomainMonthlyExpenses
              capDomainRefPRelation: $capDomainRefPRelation
              capDomainRefFRelation: $capDomainRefFRelation
              capDomainHowKnowCap: $capDomainHowKnowCap
              capDomainsLiveWith: $capDomainsLiveWith
              capDomainEmployment: $capDomainEmployment
            ) {
              capAccountAccountId
              capAccount {
                firstName
              }
            }
          }
        `,
        variables: {
          profile: this.wizardModel,
          capAccountAccountId: Constants.getUserId(),
          capCityResidence: this.capCityResidence,
          capDomainSocialELevel: this.capDomainSocialELevel,
          capDomainStudyLevel: this.capDomainStudyLevel,
          capDomainVehicleType: this.capDomainVehicleType,
          capDomainCivilStatus: this.capDomainCivilStatus,
          capDomainIncomeSalary: this.capDomainIncomeSalary,
          capDomainMonthlyExpenses: this.capDomainMonthlyExpenses,
          capDomainRefPRelation: this.capDomainRefPRelation,
          capDomainRefFRelation: this.capDomainRefFRelation,
          capDomainHowKnowCap: this.capDomainHowKnowCap,
          capDomainsLiveWith: this.capDomainsLiveWith,
          capDomainEmployment: this.capDomainEmployment
        },
        update: (cache, mutationResult) => {
          //onLogin(
          //  this.$apollo.provider.defaultClient,
          // mutationResult.data.createAccount.cellphone,
          // mutationResult.data.createAccount
          // );
          let accountId = mutationResult.data.createProfile.capAccountAccountId;
          let accountName =
            mutationResult.data.createProfile.capAccount.firstName;

          this.$apollo.mutate({
            mutation: gql`
              mutation addBackAccount(
                $profileBank: pProfileBank!
                $profileId: Int!
                $capDomainId: Int!
              ) {
                addBackAccount(
                  profileBank: $profileBank
                  capProfilesCapAccountAccountId: $profileId
                  capDomainsDomId: $capDomainId
                ) {
                  bankAccountNumber
                  bankAccountType
                }
              }
            `,
            variables: {
              profileBank: this.profileBank,
              capDomainId: this.capDomainBank,
              profileId: accountId
            },
            update: (cache, mutationResult) => {
              this.$apollo.mutate({
                mutation: gql`
                  mutation addClientJob(
                    $clientJob: pProfileClientJob!
                    $capDomainEnterpriseSectorId: Int!
                    $capDomainContractTypeId: Int!
                    $capProfileId: Int!
                  ) {
                    addClientJob(
                      clientJob: $clientJob
                      capDomainEnterpriseSectorId: $capDomainEnterpriseSectorId
                      capDomainContractTypeId: $capDomainContractTypeId
                      capProfileId: $capProfileId
                    ) {
                      clientJobId
                    }
                  }
                `,
                variables: {
                  clientJob: this.clientJob,
                  capDomainEnterpriseSectorId: this.capDomainEnterpriseSectorId,
                  capDomainContractTypeId: this.capDomainContractTypeId,
                  capProfileId: accountId
                },
                update: (cache, mutationResult) => {
                  this.$router.push("/messagePage/profileR/" + accountName);
                }
              });
            }
          });
        }
      });
    }
  }
};
</script>
